import NavigationManager from '@v2/domains/routing/components/NavigationManager'
import { selectCurrentOrganization } from '@v2/domains/user/selectors/user.selectors'
import React from 'react'
import { Outlet } from 'react-router-dom'

import { BasicTemplateWrapper as BasicTemplateBenestreamWrapper } from 'src/benestream/templates'
import { BENESTREAM_ORG_ID } from 'src/common/config'
import { BasicTemplateWrapper } from 'src/default/templates'
import { useAppSelector } from 'src/v2/store/hooks'

const AppLayout = () => {
  const currentOrganization = useAppSelector(selectCurrentOrganization)

  const isBenestream = BENESTREAM_ORG_ID === currentOrganization.id

  const Wrapper = isBenestream
    ? BasicTemplateBenestreamWrapper
    : BasicTemplateWrapper

  return (
    <Wrapper>
      <NavigationManager />
      <Outlet />
    </Wrapper>
  )
}

export default AppLayout
